export const CONFIG_DNAME_STORAGE = 'neusec_dname';
